import { useEffect, useRef, useState } from "react";
import { motion, useInView, useMotionValue, animate } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Placeholder metrics — update with verified numbers later.
const STATS = [
  { id: "years", value: 19, prefix: "", suffix: "+", label: "Years in commercial B2B" },
  { id: "saved", value: 25, prefix: "$", suffix: "M+", label: "Client costs reduced" },
  { id: "clients", value: 300, prefix: "", suffix: "+", label: "Businesses served" },
  { id: "areas", value: 5, prefix: "", suffix: "", label: "Methods for momentum" },
];

const Counter = ({ value, prefix, suffix, start }) => {
  const [display, setDisplay] = useState(0);
  const mv = useMotionValue(0);

  useEffect(() => {
    if (!start) return;
    const controls = animate(mv, value, {
      duration: 1.8,
      ease: EASE,
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return controls.stop;
  }, [start, value, mv]);

  return (
    <span>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      ref={ref}
      data-testid="stats-band"
      className="border-y border-white/10 bg-panel"
    >
      <div className="mx-auto grid max-w-[90rem] grid-cols-2 gap-y-12 px-6 py-20 md:grid-cols-4 md:px-12 md:py-24">
        {STATS.map((s, i) => (
          <motion.div
            key={s.id}
            data-testid={`stat-${s.id}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
            className="flex flex-col items-center text-center md:items-start md:text-left"
          >
            <span className="font-serif text-5xl font-medium tracking-tight text-fog md:text-7xl">
              <Counter
                value={s.value}
                prefix={s.prefix}
                suffix={s.suffix}
                start={inView}
              />
            </span>
            <span className="mt-4 max-w-[12rem] text-xs uppercase tracking-[0.25em] text-ash">
              {s.label}
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
